export const arrContainsAtLeastOneIdenticalValue = (
  array1: any,
  array2: any
) => {
  return array1.some((r: any) => array2.indexOf(r) >= 0);
};
